import { useCallback, useEffect, useRef } from 'react';
import useSelectStore from '../stores/selectStore';

export const mouseEventHandler = () => {
    const setModifierKey = useSelectStore((state) => state.setModifierKey);
    const clearSelection = useSelectStore((state) => state.clearSelection);
    const selectedIds = useSelectStore((state) => state.selectedIds);
    const selectedIdsRef = useRef(selectedIds);
    selectedIdsRef.current = selectedIds;
    // const copiedItems = useStore((state) => state.copiedItems);

    const onMouseDown = useCallback((e: Event) => {
        // handle only left button click
        // if (copiedItems !== null) {
        //     let isPressing = useStore.getState().isPressingContainer;
        //     if (isPressing === false) {
        //         useStore.setState({
        //             selectedContainer: null
        //         });
        //     }
        // }
        if ((e as MouseEvent).button === 0) {
            let el: HTMLElement = e.target as HTMLElement;
            let selectedIdsDrop = [];
            if (selectedIdsRef.current.length !== 0) {
                while (el && !el.id) {
                    el = el.parentElement;
                }
                selectedIdsDrop = selectedIdsRef.current.map(
                    (id) => id + 'dropTarget'
                );
            }

            if ((e as MouseEvent).button === 0) {
                if ((e as MouseEvent).shiftKey) {
                    setModifierKey('shift');
                } else if ((e as MouseEvent).metaKey) {
                    setModifierKey('meta');
                } else if ((e as MouseEvent).ctrlKey) {
                    setModifierKey('ctrl');
                } else if (!selectedIdsDrop.includes(el?.id)) {
                    //
                    clearSelection();
                    setModifierKey(null);
                } else {
                    setModifierKey(null);
                }
            }
        }
    }, []);
    useEffect(() => {
        window.addEventListener('mousedown', onMouseDown);

        return () => {
            window.removeEventListener('mousedown', onMouseDown);
        };
    }, [onMouseDown]);
};
